export default {
    queryRecommendCarrierByCity:
        "/gateway/huilian/recommendCarriercs/free/queryRecommendCarrierByCity", //企业认证
};



// WEBPACK FOOTER //
// ./src/marketingOnline/rentalCar/api.js